import { Switch } from '@zoopla-eng/zds/switches';

type LetAgreedProps = {
    onCheckedChange: (include_rented: string) => void;
    on: boolean;
};

export const LetAgreed = ({ onCheckedChange, on }: LetAgreedProps) => {
    return (
        <Switch
            name="include_rented"
            label="Show let or let agreed"
            on={on}
            onCheckedChange={(include_rented) => {
                onCheckedChange(String(include_rented));
            }}
        />
    );
};
